export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6487.ed0a8401.jpg";